import { render, staticRenderFns } from "./BizLogin.vue?vue&type=template&id=e61e0fc4&scoped=true"
import script from "./BizLogin.vue?vue&type=script&lang=js"
export * from "./BizLogin.vue?vue&type=script&lang=js"
import style0 from "./BizLogin.vue?vue&type=style&index=0&id=e61e0fc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61e0fc4",
  null
  
)

export default component.exports